import {
  SelectContent,
  SelectItem,
  SelectItemGroup,
  SelectLabel,
  SelectRoot,
  SelectTrigger,
  SelectValueText,
} from '../../../components'

import React from 'react'
import { SelectRootProps } from '@chakra-ui/react'

export type SelectGroupInputProps = SelectRootProps & {
  label: React.ReactNode
  placeholder?: string
  clearable?: boolean
}

export type ItemGroup = {
  value: string
  label: string
  group: string
}

export const SelectGroupInput = ({
  label,
  placeholder,
  clearable,
  ...props
}: SelectGroupInputProps) => {
  const categories = props.collection.items.reduce((acc, item: ItemGroup) => {
    const group = acc.find((group: ItemGroup) => group.group === item.group)
    if (group) {
      group.items.push(item)
    } else {
      acc.push({ group: item.group, items: [item] })
    }
    return acc
  },
  [] as { group: string; items: (typeof props.collection)["items"] }[],
)

  return (
    <SelectRoot {...props}>
      <SelectLabel>{label}</SelectLabel>
      <SelectTrigger clearable={clearable}>
        <SelectValueText placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {categories.map((category: { group: string,  items: []}) => (
          <SelectItemGroup key={category.group} label={category.group}>
            {category.items.map((item: { value: string | number, label: string}) => (
              <SelectItem item={item} key={item.value}>
                {item.label}
              </SelectItem>
            ))}
          </SelectItemGroup>
        ))}
      </SelectContent>
    </SelectRoot>
  )
}
